
export interface SpinHistoryItem {
  person: string;
  drink: string | null;
  drinkEmoji: string | null;
  timestamp: number;
}

interface SpinHistoryProps {
  history: SpinHistoryItem[];
}

export default function SpinHistory({ history }: SpinHistoryProps) {
  if (history.length === 0) return null;

  return (
    <div className="bg-white rounded-2xl shadow-lg shadow-gray-200 p-5">
      <h3 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2">
        <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-[#2349FF] to-[#1a38cc] flex items-center justify-center">
          <i className="ri-history-line text-white text-sm"></i>
        </div>
        Spin History
      </h3>
      <div className="space-y-1.5">
        {history.map((item, index) => (
          <div 
            key={item.timestamp} 
            className={`flex items-center gap-3 p-2.5 rounded-lg ${
              item.drink ? 'bg-gradient-to-r from-amber-50 to-orange-50' : 'bg-gray-50'
            }`}
          >
            <span className="text-xs font-bold text-gray-300 w-5">#{index + 1}</span>
            {item.drinkEmoji ? (
              <span className="text-lg w-6 text-center">{item.drinkEmoji}</span>
            ) : (
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-beer-line text-gray-300 text-sm"></i>
              </span>
            )}
            <div className="flex-1 min-w-0">
              <span className="text-sm font-semibold text-gray-800 truncate block">{item.person}</span>
              <span className="text-xs text-gray-500">
                {item.drink ? `bought ${item.drink}` : 'N/A'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
